// This would be inside the state.ts model file/folder
export interface IState<T> {
  value: T;
  display_name: string;
  message?: string;
  icon?: string;
  color?: string;
}

export class State<T> implements IState<T> {
  readonly value: T;
  readonly display_name: string;
  readonly message?: string;
  readonly icon?: string;
  readonly color?: string;

  constructor(data: IState<T>) {
    this.value = data.value;
    this.display_name = data.display_name;

    if (data.message) {
      this.message = data.message;
    }
    if (data.icon) {
      this.icon = data.icon;
    }
    if (data.color) {
      this.color = data.color;
    }
  }

  public toString(): string {
    return this.display_name.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
}
